module.exports = __webpack_public_path__ + "static/media/03-luiz-nivardo.d6a1da62.webp";